import { SelectOption } from 'modules/queryBuilder/contexts/visualComponents';
import { SelectValueType } from 'ui/selects';
import { isDefined, isUndefined } from 'utils/tsHelpers';
import { convertToBaseOptions } from '../../utils';

/** gets variables needed for multi selects */
export const getMultiSelectVariables = <TValue extends SelectValueType = string>(
  values: TValue[],
  options: SelectOption<TValue>[],
) => {
  const valueOptionMap = values.reduce((acc: Record<string, SelectOption<TValue>>, value) => {
    const key = `${value}`;
    const selectedOption = options.find((option) => option.value === value);
    return isDefined(selectedOption) && isUndefined(acc[key])
      ? { ...acc, [key]: selectedOption }
      : { ...acc, [key]: { title: `${value}`, value } };
  }, {});

  const optionsWithStringValues = options.map((option) => ({
    ...option,
    value: `${option.value}`,
  }));
  const selectedValues = Object.values(valueOptionMap);
  const selectedBaseOptions = convertToBaseOptions(selectedValues, true);
  const baseOptions = convertToBaseOptions<string>(optionsWithStringValues, true);

  return {
    selectedValues,
    baseOptions,
    selectedBaseOptions,
  };
};
